import React, { Component, useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AdminLayout from "./components/AdminLayout";
import configureAppStore from "./config/configureStore";
import { LanguageProvider } from "./i18n/LanguageContext";

import "./custom.css";


import { Toaster } from "./components/ui/toaster";
import SuccessNotification from "./components/ui/SuccessNotification";
import { SuccessNotificationProvider } from "./hooks/use-success-notification";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import viCustom from "./utils/viCustom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TooltipProvider } from "./components/ui/tooltip";
import AdminRoutes from "./AdminRoutes";
import { Provider } from "react-redux";
import { RoleProvider } from "./contexts/RoleContext";
import { Navigate } from "react-router-dom";

const store = configureAppStore();

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior; // tắt smooth tạm thời để khỏi “nhảy”
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, [pathname]);

  return null;
}

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Provider store={store}>
        <LanguageProvider>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={viCustom}
            >
              <RoleProvider>
                <TooltipProvider>
                  <SuccessNotificationProvider>
                    <SuccessNotification />

                    <Toaster />
                    <ScrollToTop />
                    <Routes>
                      {/* Nhóm ADMIN (bắt đầu /config) */}
                      <Route path="/" element={<AdminLayout />}>
                        <Route
                          index
                          element={<Navigate to="login" replace />}
                        />

                        {AdminRoutes.map(({ element, ...rest }, i) => (
                          <Route key={i} {...rest} element={element} />
                        ))}
                      </Route>

                      {/* {AppRoutes.map((route, index) => {
                  const { element, ...rest } = route;
                  return <Route key={index} {...rest} element={element} />;
                })} */}
                    </Routes>
                  </SuccessNotificationProvider>
                </TooltipProvider>
              </RoleProvider>
            </LocalizationProvider>
        </LanguageProvider>
      </Provider>
    );
  }
}
